import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { useSYS1020_R01Store } from "./Store_SYS1020_R01";

export const SearchSection_SYS1020_R01 = () => {
    const {
        SYS1020_R01Filter,
        setSYS1020_R01Filter,
    } = useSYS1020_R01Store();
    const { messageSrcList, messageTypeList } = useCommonCodeStore();

    return (
        <SearchSectionForm>
            <SearchDropDownForm
                label="발생구분"
                value={SYS1020_R01Filter.messageSrc}
                optionList={messageSrcList}
                onChangeItem={(item) => setSYS1020_R01Filter({ messageSrc: item?.minorCd ?? "" })}
            />
            <SearchDropDownForm
                label="메시지구분"
                value={SYS1020_R01Filter.messageType}
                optionList={messageTypeList}
                onChangeItem={(item) => setSYS1020_R01Filter({ messageType: item?.minorCd ?? "" })}
                wrapperOption={{
                    wrapperStyle: "w-[215px] min-w-[215px] mr-[10px]",
                    titleStyle: "w-[60px] min-w-[60px] text-left",
                    selectStyle: "w-[100px] min-w-[100px]",
                }}
            />
        </SearchSectionForm>
    );
};
